<template>
  <v-dialog v-model="visible" max-width="100%">
    <v-card>
      <v-card-title>ESTIMACIÓN PRESUPUESTARIA</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-row dense>
          <v-col cols="12">
            <span class="h4">ESTIMACIÓN DE INGRESOS POR GESTIÓN</span>
            <v-btn small class="ml-4" @click="descargar">
              <v-icon>mdi-microsoft-excel</v-icon>

              Exportar
            </v-btn>
          </v-col>

          <v-col cols="12">
            <ag-grid-vue
              :gridOptions="gridOptions"
              class="ag-theme-balham ag-grid-table-estimacion-3"
              :columnDefs="columnDefs"
              :defaultColDef="{ ...defaultColDef, floatingFilter: false }"
              @grid-ready="onGridReady"
              :rowData="itemsAgrupadosPorPrograma"
              colResizeDefault="shift"
              :animateRows="false"
              :pagination="false"
              :rowClassRules="rowClassRules"
              @first-data-rendered="onFirstDataRendered"
              :alwaysShowVerticalScroll="true"
              :suppressPaginationPanel="true">
            </ag-grid-vue>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="cerrar"> Cerrar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import AgGridMixin from '../mixins/ag-grid-mixin';
import IngresoServices from '../services/ingresos';
import { formatearValorAMoneda } from '../utils';
import ReportesExcelService from '../services/reportes-excel';
import DescargarExcelMixin from '../mixins/descargar-excel.mixin';

export default {
  name: 'VerEstimacionIngresoGestion',
  mixins: [AgGridMixin, DescargarExcelMixin],
  data() {
    return {
      gestion: null,
      items: [],
      itemsAgrupadosPorPrograma: [],
      visible: false,
      columnDefs: [
        {
          headerName: 'PROGRAMA',
          field: 'nombre_programa',
          filter: false,
          minWidth: 400,
          maxWidth: 400,
        },
        {
          headerName: 'NUM. CUOTAS',
          field: 'numero_cuotas',
          filter: false,
          minWidth: 110,
          maxWidth: 110,
          type: 'numericColumn',
        },
        {
          headerName: 'CANT. EST.',
          field: 'cantidad_inscritos_estimada',
          filter: false,
          minWidth: 100,
          maxWidth: 100,
          type: 'numericColumn',
        },
        {
          headerName: 'CANT. DES.',
          field: 'desertores',
          filter: false,
          minWidth: 100,
          maxWidth: 100,
          type: 'numericColumn',
        },
        {
          headerName: 'CANT. CONT.',
          field: 'cantidad_contado',
          filter: false,
          minWidth: 100,
          maxWidth: 100,
          type: 'numericColumn',
        },
        {
          headerName: 'DETALLE',
          headerComponentParams: {
            template: /*html*/ `
            <table width="100%" style="border-collapse">
              <tr>
                  <th style="font-size: 13px; font-weight: 600; width: 100px;">CÓDIGO</th>
                  <th style="font-size: 13px; font-weight: 600; width: 300px; max-width: 300px;">CUENTA</th>
                  <th style="font-size: 13px; font-weight: 600; width: 100px; text-align: right;">ENERO</th>
                  <th style="font-size: 13px; font-weight: 600; width: 100px; text-align: right;">FEBRERO</th>
                  <th style="font-size: 13px; font-weight: 600; width: 100px; text-align: right;">MARZO</th>
                  <th style="font-size: 13px; font-weight: 600; width: 100px; text-align: right;">ABRIL</th>
                  <th style="font-size: 13px; font-weight: 600; width: 100px; text-align: right;">MAYO</th>
                  <th style="font-size: 13px; font-weight: 600; width: 100px; text-align: right;">JUNIO</th>
                  <th style="font-size: 13px; font-weight: 600; width: 100px; text-align: right;">JULIO</th>
                  <th style="font-size: 13px; font-weight: 600; width: 100px; text-align: right;">AGOSTO</th>
                  <th style="font-size: 13px; font-weight: 600; width: 100px; text-align: right;">SEPTIEMBRE</th>
                  <th style="font-size: 13px; font-weight: 600; width: 100px; text-align: right;">OCTUBRE</th>
                  <th style="font-size: 13px; font-weight: 600; width: 100px; text-align: right;">NOVIEMBRE</th>
                  <th style="font-size: 13px; font-weight: 600; width: 100px; text-align: right;">DICIEMBRE</th>
                  <th style="font-size: 13px; font-weight: 600; width: 100px; text-align: right;">TOTAL</th>
              </tr>
            </table>`,
          },
          cellRenderer: function (param) {
            if (param.node.rowPinned) {
              return undefined;
            } else {
              let detalle = /*html*/ `<table width="100%" style="border-collapse: collapse;">`;

              for (let index = 0; index < param.data.estimaciones.length; index++) {
                const estimacion = param.data.estimaciones[index];

                detalle += /*html*/ `
                <tr>
                    <td style="width: 100px;">
                        ${estimacion.codigo}
                    </td>
                    <td style="width: 300px; max-width: 300px; ${
                      estimacion.clasificador_nombre == 'Totales' ? 'font-weight: bolder; font-size: 12px;' : ''
                    }">
                      ${estimacion.clasificador_nombre}
                    </td>
                    <td style="width: 100px; text-align: right; ${
                      estimacion.clasificador_nombre == 'Totales' ? 'font-weight: bolder; font-size: 12px;' : ''
                    }">
                      ${formatearValorAMoneda(estimacion.enero)}
                    </td>
                    <td style="width: 100px; text-align: right; ${
                      estimacion.clasificador_nombre == 'Totales' ? 'font-weight: bolder; font-size: 12px;' : ''
                    }">
                      ${formatearValorAMoneda(estimacion.febrero)}
                    </td>
                    <td style="width: 100px; text-align: right; ${
                      estimacion.clasificador_nombre == 'Totales' ? 'font-weight: bolder; font-size: 12px;' : ''
                    }">
                      ${formatearValorAMoneda(estimacion.marzo)}
                    </td>
                    <td style="width: 100px; text-align: right; ${
                      estimacion.clasificador_nombre == 'Totales' ? 'font-weight: bolder; font-size: 12px;' : ''
                    }">
                      ${formatearValorAMoneda(estimacion.abril)}
                    </td>
                    <td style="width: 100px; text-align: right; ${
                      estimacion.clasificador_nombre == 'Totales' ? 'font-weight: bolder; font-size: 12px;' : ''
                    }">
                      ${formatearValorAMoneda(estimacion.mayo)}
                    </td>
                    <td style="width: 100px; text-align: right; ${
                      estimacion.clasificador_nombre == 'Totales' ? 'font-weight: bolder; font-size: 12px;' : ''
                    }">
                      ${formatearValorAMoneda(estimacion.junio)}
                    </td>
                    <td style="width: 100px; text-align: right; ${
                      estimacion.clasificador_nombre == 'Totales' ? 'font-weight: bolder; font-size: 12px;' : ''
                    }">
                      ${formatearValorAMoneda(estimacion.julio)}
                    </td>
                    <td style="width: 100px; text-align: right; ${
                      estimacion.clasificador_nombre == 'Totales' ? 'font-weight: bolder; font-size: 12px;' : ''
                    }">
                      ${formatearValorAMoneda(estimacion.agosto)}
                    </td>
                    <td style="width: 100px; text-align: right; ${
                      estimacion.clasificador_nombre == 'Totales' ? 'font-weight: bolder; font-size: 12px;' : ''
                    }">
                      ${formatearValorAMoneda(estimacion.septiembre)}
                    </td>
                    <td style="width: 100px; text-align: right; ${
                      estimacion.clasificador_nombre == 'Totales' ? 'font-weight: bolder; font-size: 12px;' : ''
                    }">
                      ${formatearValorAMoneda(estimacion.octubre)}
                    </td>
                    <td style="width: 100px; text-align: right; ${
                      estimacion.clasificador_nombre == 'Totales' ? 'font-weight: bolder; font-size: 12px;' : ''
                    }">
                      ${formatearValorAMoneda(estimacion.noviembre)}
                    </td>
                    <td style="width: 100px; text-align: right; ${
                      estimacion.clasificador_nombre == 'Totales' ? 'font-weight: bolder; font-size: 12px;' : ''
                    }">
                      ${formatearValorAMoneda(estimacion.diciembre)}
                    </td>
                    <td style="width: 100px; text-align: right; ${
                      estimacion.clasificador_nombre == 'Totales' ? 'font-weight: bolder; font-size: 12px;' : ''
                    }">
                      ${formatearValorAMoneda(estimacion.total)}
                    </td>
                </tr>`;
              }

              if (param.data.nombre_programa != 'Totales') {
                const nombrePrograma = param.data.nombre_programa;
                detalle += /*html*/ `
                <tr>
                  <td style="width: 100px; border-top: 1px solid #e4e9f2; font-weight: bold;"></td>
                  <td style="width: 300px; max-width: 300px; border-top: 1px solid #e4e9f2; font-weight: bold;">
                    Total ${nombrePrograma.substring(0, 35) + (nombrePrograma.length > 35 ? '...' : '')}
                  </td>
                  <td style="width: 100px; text-align: right; border-top: 1px solid #e4e9f2; font-weight: bold;">
                    ${formatearValorAMoneda(param.data.estimaciones.reduce((a, b) => a + parseFloat(b.enero), 0))}  
                  </td>
                  <td style="width: 100px; text-align: right; border-top: 1px solid #e4e9f2; font-weight: bold;">
                    ${formatearValorAMoneda(param.data.estimaciones.reduce((a, b) => a + parseFloat(b.febrero), 0))}  
                  </td>
                  <td style="width: 100px; text-align: right; border-top: 1px solid #e4e9f2; font-weight: bold;">
                    ${formatearValorAMoneda(param.data.estimaciones.reduce((a, b) => a + parseFloat(b.marzo), 0))}  
                  </td>
                  <td style="width: 100px; text-align: right; border-top: 1px solid #e4e9f2; font-weight: bold;">
                    ${formatearValorAMoneda(param.data.estimaciones.reduce((a, b) => a + parseFloat(b.abril), 0))}  
                  </td>
                  <td style="width: 100px; text-align: right; border-top: 1px solid #e4e9f2; font-weight: bold;">
                    ${formatearValorAMoneda(param.data.estimaciones.reduce((a, b) => a + parseFloat(b.mayo), 0))}  
                  </td>
                  <td style="width: 100px; text-align: right; border-top: 1px solid #e4e9f2; font-weight: bold;">
                    ${formatearValorAMoneda(param.data.estimaciones.reduce((a, b) => a + parseFloat(b.junio), 0))}  
                  </td>
                  <td style="width: 100px; text-align: right; border-top: 1px solid #e4e9f2; font-weight: bold;">
                    ${formatearValorAMoneda(param.data.estimaciones.reduce((a, b) => a + parseFloat(b.julio), 0))}  
                  </td>
                  <td style="width: 100px; text-align: right; border-top: 1px solid #e4e9f2; font-weight: bold;">
                    ${formatearValorAMoneda(param.data.estimaciones.reduce((a, b) => a + parseFloat(b.agosto), 0))}
                  </td>
                  <td style="width: 100px; text-align: right; border-top: 1px solid #e4e9f2; font-weight: bold;">
                    ${formatearValorAMoneda(
                      param.data.estimaciones.reduce((a, b) => a + parseFloat(b.septiembre), 0),
                    )}  
                  </td>
                  <td style="width: 100px; text-align: right; border-top: 1px solid #e4e9f2; font-weight: bold;">
                    ${formatearValorAMoneda(param.data.estimaciones.reduce((a, b) => a + parseFloat(b.octubre), 0))}  
                  </td>
                  <td style="width: 100px; text-align: right; border-top: 1px solid #e4e9f2; font-weight: bold;">
                    ${formatearValorAMoneda(param.data.estimaciones.reduce((a, b) => a + parseFloat(b.noviembre), 0))}  
                  </td>
                  <td style="width: 100px; text-align: right; border-top: 1px solid #e4e9f2; font-weight: bold;">
                    ${formatearValorAMoneda(param.data.estimaciones.reduce((a, b) => a + parseFloat(b.diciembre), 0))}  
                  </td>
                  <td style="width: 100px; text-align: right; border-top: 1px solid #e4e9f2; font-weight: bold;">
                    ${formatearValorAMoneda(param.data.estimaciones.reduce((a, b) => a + parseFloat(b.total), 0))}  
                  </td>
                </tr>`;
              }

              detalle += /*html*/ `</table>`;

              return detalle;
            }
          },
          autoHeight: true,
          suppressSizeToFit: true,
          filter: false,
          minWidth: 1700,
        },
      ],
    };
  },
  methods: {
    abrir(gestion) {
      this.gestion = gestion;
      this.itemsAgrupadosPorPrograma = [];
      this.items = [];
      this.visible = true;
      this.listar();
    },
    cerrar() {
      this.visible = false;
      this.items = [];
    },
    async listar() {
      try {
        const params = {
          sede_id: this.$store.state.CARGO.sede.id,
          gestion_id: this.gestion?.id,
        };
        const response = await IngresoServices.findGestion({ params });

        this.items = response.data.datos;

        response.data.datos.map((estimacion) => {
          const {
            nombre_programa,
            numero_cuotas,
            cantidad_inscritos_estimada,
            sede,
            desertores,
            cantidad_contado,
            clasificador_nombre,
            estimacion_id,
            ...estimacionData
          } = estimacion;
          const nombrePrograma = nombre_programa || 'Totales';
          const clasificadorNombre = clasificador_nombre || 'Totales';
          const estimacionId = estimacion_id || 'Totales';

          const indice = this.itemsAgrupadosPorPrograma.findIndex((item) => {
            return item.estimacion_id === estimacionId;
          });

          if (indice != -1) {
            this.itemsAgrupadosPorPrograma[indice].estimaciones.push({
              estimacion_id: estimacionId,
              clasificador_nombre: clasificadorNombre,
              ...estimacionData,
            });
          } else {
            this.itemsAgrupadosPorPrograma.push({
              estimacion_id: estimacionId,
              nombre_programa: nombrePrograma,
              numero_cuotas,
              cantidad_inscritos_estimada,
              sede,
              desertores,
              cantidad_contado,
              estimaciones: [
                {
                  clasificador_nombre: clasificadorNombre,
                  ...estimacionData,
                },
              ],
            });
          }
        });
      } catch (err) {
        window.console.log(err);
      }
    },
    descargar() {
      return this.descargarExcel(ReportesExcelService.estimacionesGestion, null, {
        params: {
          sede_id: this.$store.state.CARGO.sede.id,
          gestion_id: this.gestion?.id,
        },
      });
    },
  },
  computed: {},
};
</script>

<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';

.ag-grid-table-estimacion-3 {
  height: calc(var(--vh, 1vh) * 100 - 20.5rem);
}
</style>